<script setup>
import {computed} from 'vue'
import {useToastsStore} from '@/stores/toasts'
import Toast from "./Toast"

const toastsStore = useToastsStore()

const items = computed(() => toastsStore.items)
</script>

<template>
    <div v-if="items && items.length" class="toast-container position-fixed top-0 end-0 p-3">
        <Toast v-bind="item" v-for="(item, index) in items" :key="index"/>
    </div>
</template>